import axios from "axios";
export const getApi = async (method, url, data = "") => {
  const options = {
    method: method,
    url: url,
  };
  if (method === "post") {
    options["data"] = data;
  }
  try {
    const res = await axios(options);

    return res;
  } catch (e) {
    let messData = "";

    if (e.request.response) {
      if (typeof JSON.parse(e.request.response).message === "object") {
        messData = JSON.parse(e.request.response).message;
        Object.keys(messData).forEach((item) => {
          messData[item] = messData[item][0];
        });
        return { error: true, message: messData, errorType: "multi" };
      } else {
        messData = JSON.parse(e.request.response).message;
        return { error: true, message: messData, errorType: "single" };
      }
    }
  }
};
